import React from 'react';
import { LanguageTestPanel as LanguageTestPanelComponent } from '@/components/dev/LanguageTestPanel';

const LanguageTestPanel = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Language System Testing</h1>
          <p className="text-muted-foreground">
            Test and debug the multilingual routing, language detection, and navigation system.
          </p>
        </div>
        
        <LanguageTestPanelComponent />
      </div>
    </div>
  );
};

export default LanguageTestPanel;